import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Chi può iscriversi all'Associazione ACDT?",
    a: "Possono iscriversi professionisti, imprenditori, freelance, formatori, consulenti digitali e chiunque desideri costruire competenze certificate nel digitale, nella tecnologia e nella sostenibilità. Non è richiesto un titolo specifico.",
  },
  {
    q: "Qual è la differenza tra Tessera, Corso e Registro?",
    a: "La Tessera (€ 50) ti rende socio ufficiale ACDT. Il Corso (€ 99 in promo, listino € 179) ti abilita come Consulente Digitale Tecnologico e di Sostenibilità. Il Registro (€ 69,90) ti permette di esercitare la professione con timbro ufficiale e riconoscimento Agg. MIMIT.",
  },
  {
    q: "Quanto dura l'iscrizione e come si rinnova?",
    a: "Ha validità 365 giorni dalla data di iscrizione. Per rinnovare è sufficiente effettuare il pagamento del rinnovo dalla propria Area Riservata.",
  },
  {
    q: "Il corso è riconosciuto ufficialmente?",
    a: "Sì. Il percorso è strutturato in coerenza con la Legge 4/2013 sulle professioni non organizzate. Al termine ricevi un attestato di qualificazione, Crediti Formativi (CFP) e puoi richiedere l'iscrizione al Registro Nazionale.",
  },
  {
    q: "Come posso pagare?",
    a: "Puoi pagare con PayPal, Carta di credito (Stripe), Google Pay, Apple Pay, Klarna (3 rate senza interessi) o Bonifico bancario. Tutti i pagamenti sono sicuri e protetti SSL.",
  },
  {
    q: "La Tutela Digitale è inclusa?",
    a: "Sì, la Consulenza Tutela Digitale base è inclusa in tutti e tre i pacchetti ACDT come servizio gratuito di assistenza e protezione per i soci.",
  },
];

export default function HomeFAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="relative py-24 md:py-28">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12 reveal">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-slate-200 text-[12px] font-semibold text-[#102a6b] shadow-sm">
            <HelpCircle className="h-3.5 w-3.5 text-[#f59e0b]" />
            Domande frequenti
          </div>
          <h2 className="mt-4 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
            Tutto quello che vuoi sapere
          </h2>
          <p className="mt-4 text-slate-600">
            Risposte rapide alle domande più comuni su ACDT, i pacchetti e il corso.
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={f.q}
                className="reveal rounded-2xl border border-slate-200 bg-white overflow-hidden"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <button
                  type="button"
                  onClick={() => setOpen(active ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left"
                >
                  <span className="text-[15px] md:text-base font-bold text-[#0a1f55]">{f.q}</span>
                  <div className={`h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0 transition-all ${active ? "bg-[#102a6b] text-white" : "text-[#102a6b]"}`}>
                    <ChevronDown className={`h-4 w-4 transition-transform ${active ? "rotate-180" : ""}`} />
                  </div>
                </button>
                <div className={`overflow-hidden transition-[max-height] duration-300 ${active ? "max-h-60" : "max-h-0"}`}>
                  <p className="px-5 md:px-6 pb-5 text-[14.5px] text-slate-600 leading-relaxed">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
